module.exports = __webpack_public_path__ + "static/media/honey.1e9b1ec5.jpg";